export const kiemKe = {
  sections: {
    list: { title: '盘点' },
    detail: { title: '盘点单详情' },
  },
  titles: { add: '新建盘点单' },
  columns: {
    code: '单号',
    chiNhanh: '门店',
    summary: '信息',
    status: '状态',
    time: '时间',
    ngayCanBang: '平账日期',
    tongSlThucTe: '实盘数量',
    tongGiaTriThucTe: '实盘金额',
    tongChenhLech: '总差异',
    slLechTang: '盘盈数量',
    slLechGiam: '盘亏数量',
    note: '备注',
    creator: '创建人',
    maPhieuKho: '库存单',
  },
  fields: {
    code: '单号',
    chiNhanh: '门店',
    time: '时间',
    note: '备注',
    status: '状态',
    creator: '创建人',
    lines: '盘点明细',
    product: '商品',
    productSearch: '搜索编码或名称...',
    tonKho: '账面库存',
    soLuongThucTe: '实盘数量',
    soLuongLech: '差异',
    tongChenhLech: '总差异',
    slLechTang: '盘盈数量',
    slLechGiam: '盘亏数量',
    tongGiaTriThucTe: '实盘金额',
    ngayCanBang: '平账日期',
    actions: '操作',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    donViTinh: '单位',
    tonKhoHienTai: '账面库存',
    thucTe: '实盘',
    slLech: '差异数量',
    donGiaVon: '成本单价',
    giaTriLech: '差异金额',
    serialImei: '序列号/IMEI',
    dateSanPham: '商品日期',
    lyDoKiemKe: '盘点原因',
    lineNote: '备注',
  },
  form: {
    sectionHeader: '单据信息',
    sectionLines: '盘点明细',
    maPhieu: '单号',
    maPhieuAuto: '保存时自动生成',
    thoiGian: '时间',
    note: '备注',
    maSp: '商品编码',
    tenSp: '商品名称',
    donViTinh: '单位',
    tonKho: '账面库存',
    soLuongThucTe: '实盘',
    soLuongLech: '差异数量',
    giaVon: '成本单价',
    giaTriLech: '差异金额',
    serialImei: '序列号/IMEI',
    dateSanPham: '商品日期',
    lyDoKiemKe: '盘点原因',
    lineNote: '备注',
    productSearch: '搜索编码或名称',
    save: '保存',
    lineCount: '{count} 个商品',
    tongSoMatHang: '商品数',
    tongSlThucTe: '实盘合计',
    tongChenhLech: '差异数量合计',
    tongGiaTriLech: '差异金额合计',
  },
  detailTabs: {
    chung: '总览',
    generalInfo: '信息',
    chiTietHang: '明细',
  },
  status: {
    phieuTam: '暂存',
    daCanBang: '已平账',
    daHuy: '已取消',
    daXoa: '已删除',
  },
  actions: {
    addLine: '添加行',
    complete: '完成',
    cancelVoucher: '取消',
    importExcel: '导入 Excel',
    exportExcel: '导出 Excel',
    downloadTemplate: '下载模板',
    copy: '复制单据',
    dongY: '同意',
  },
  formImport: {
    title: '从 Excel 导入盘点明细',
    confirmTitle: '确认盘点明细列表',
    errorTitle: 'Excel 文件无效',
    errorHint: '请重新选择符合模板的文件。',
    description: '选择 Excel 文件（商品编码、数量），核对列表后确认写入明细表。',
    chooseFile: '选择文件',
    confirm: '确认列表',
    addValidLines: '添加有效行（{count}）',
    previewSummary: '匹配 {matched}/{total} 行',
    colStatus: '状态',
    statusOk: '已匹配',
    statusMissing: '未找到',
    noSheet: '文件没有数据工作表。',
    noData: '文件没有有效商品行。',
    needMatched: '没有可写入的匹配商品编码。',
    allUnmatched: '没有匹配到任何商品编码（{total} 行）。',
    someUnmatched: '{count} 行未找到商品编码 — 已跳过。',
    applySuccess: '已将 {success}/{total} 行写入单据。',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  filter: {
    searchPlaceholder: '按盘点单号搜索...',
    trangThai: '状态',
    nguoiTao: '创建人',
    tuNgay: '开始日期',
    denNgay: '结束日期',
    sortDir: '排序',
    asc: '升序',
    desc: '降序',
  },
  filters: {
    all: '全部',
    fromDate: '从',
    toDate: '到',
    dateRangePlaceholder: '选择日期范围',
    dateSection: '时间',
    statusSection: '状态',
    peopleSection: '创建人',
    locChung: '通用筛选',
    maPhieu: '单号',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
  },
  placeholders: {
    formTitle: '创建/编辑盘点单',
    formBody: '填写表头与盘点商品明细。',
    codeAuto: '留空自动生成 KK 编号',
  },
  canBangLo: {
    title: '平衡时分配批次 / IMEI',
    hint: '按批次 / IMEI 管理的商品有差异：为盘盈部分录入批次 / IMEI（入库单），为盘亏部分选择批次 / IMEI（出库单）。',
    du: '盘盈 {qty} — 计入调整入库单',
    thieu: '盘亏 {qty} — 选择调整出库单的批次 / IMEI',
    maLo: '批次 / IMEI',
    hanSuDung: '有效期',
    tonLo: '批次库存',
    soLuong: '数量',
    themDong: '添加批次 / IMEI',
    daPhanBo: '已分配 {done} / {total}',
    canMaLo: '请为所有盘盈行填写批次 / IMEI。',
    chuaDu: '商品 {ma}：分配合计必须为 {total}。',
    vuotTon: '商品 {ma}：批次 {lo} 仅剩 {ton}。',
    xacNhan: '平衡',
    huy: '关闭',
    loadError: '无法加载批次列表。',
  },
  messages: {
    loadError: '无法加载盘点单列表。',
    soKhongDuocAm: '实际数量不能为负数。',
    deleteSuccess: '已删除盘点单。',
    createSuccess: '创建盘点单成功。',
    updateSuccess: '更新盘点单成功。',
    completeSuccess: '盘点完成，已调整库存。',
    cancelSuccess: '已取消盘点单。',
    importSuccess: '导入 Excel 成功。',
    copySuccess: '已复制盘点单。',
    noData: '暂无盘点单。',
    noLines: '暂无明细。',
    listSummary: '共 {count} 条',
    needMaSp: '请为已添加的行选择商品编码。',
    needLinesToComplete: '盘点单没有可平账的商品。',
    needSoLuongThucTe: '平账前必须填写所有商品的实际数量（缺 {count} 行：{mas}）。',
    confirmComplete: '完成单据 {name}？库存将被平账。',
    confirmCompleteWarn: '将创建调整入/出库单并更新库存。',
    confirmCompleteHint: '请重新选择盘点时间 — 同时作为入/出库单据日期。',
    confirmCancelVoucher: '取消单据 {name}？此操作无法撤销。',
    confirmCancelDaCanBang: '取消单据 {name}？相关调整入/出库单将一并取消并回滚库存。',
  },
}
